<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  data() {
    return {
      isUserLeaving: false,
      isReloading: false
    };
  },
  mounted() {
    // 初始化用户数据
    this.$store.dispatch("initUserData");
    // 监听页面关闭事件
    window.addEventListener("beforeunload", this.handleBeforeUnload);
    // 监听页面可见性变化
    document.addEventListener("visibilitychange", this.handleVisibilityChange);

    // 检查是否是页面重新加载
    if (performance.navigation.type === 1) {
      this.isReloading = true;
    }
  },
  beforeDestroy() {
    // 移除事件监听器
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
    document.removeEventListener(
      "visibilitychange",
      this.handleVisibilityChange
    );
  },
  methods: {
    // 页面关闭前处理
    handleBeforeUnload() {
      this.isUserLeaving = true;
      // 只清除sessionStorage，保留localStorage中的"记住我"数据
      sessionStorage.clear();
    },
    // 页面可见性变化处理
    handleVisibilityChange() {
      if (document.visibilityState === "hidden") {
        // 页面隐藏时，可能是用户切换标签页或最小化
        // 不清除缓存，保持用户状态
      }
    }
  },
  destroyed() {
    // 只在用户主动离开且不是重新加载时清除sessionStorage
    if (this.isUserLeaving && !this.isReloading) {
      sessionStorage.clear();
    }
  }
};
</script>
<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: relative;
}

* {
  box-sizing: border-box;
}
</style>
